import { useEffect, useState } from 'react';

/**
 * Partage le lien de l'application — pas celui d'un voyage.
 *
 * Deux chemins selon l'appareil. Sur mobile, `navigator.share` ouvre la
 * feuille de partage du système : l'utilisateur choisit lui-même Messages,
 * WhatsApp ou le courrier, et rien ne transite par nous. Ailleurs, cette API
 * n'existe pas : on se rabat sur le presse-papiers, qui demande alors de
 * coller le lien à la main.
 *
 * Le presse-papiers peut être refusé — contexte non sécurisé, réglage du
 * navigateur. On le dit plutôt que de laisser croire à une copie qui n'a pas
 * eu lieu.
 */
export function PartagerApplication({ className = 'laterale__lien' }) {
  const [etat, setEtat] = useState(null);

  // Le message de confirmation s'efface tout seul : laissé en place, il finit
  // par décrire une action vieille de dix minutes.
  useEffect(() => {
    if (etat !== 'copie') return undefined;
    const minuterie = setTimeout(() => setEtat(null), 4000);
    return () => clearTimeout(minuterie);
  }, [etat]);

  async function partager() {
    setEtat(null);
    const url = window.location.origin;
    const invitation = {
      title: 'HolidAI',
      text: 'Je prépare mes voyages avec HolidAI, un planificateur assisté par IA.',
      url,
    };

    if (navigator.share) {
      try {
        await navigator.share(invitation);
        return;
      } catch (echec) {
        // Fermer la feuille de partage n'est pas une erreur : c'est un
        // renoncement, et retomber sur la copie ferait le contraire de ce que
        // l'utilisateur vient de décider.
        if (echec.name === 'AbortError') return;
      }
    }

    try {
      await navigator.clipboard.writeText(url);
      setEtat('copie');
    } catch {
      setEtat('echec');
    }
  }

  return (
    <>
      <button className={className} type="button" onClick={partager}>
        {etat === 'copie' ? 'Lien copié' : 'Inviter des amis'}
      </button>
      {etat === 'echec' && (
        <p className="aide" role="alert">
          Copie impossible. L’adresse à transmettre est {window.location.origin}.
        </p>
      )}
      {/* Annonce le succès aux lecteurs d'écran : le changement de libellé du
          bouton, lui, ne serait pas relu. */}
      <span className="invisible" role="status">
        {etat === 'copie' ? 'Lien de l’application copié' : ''}
      </span>
    </>
  );
}
